import styles from './Sections/pointsDetails.module.css';

const redeemRewardsStyle = {
    outerContainer: `flex flex-col gap-[20px] 
                     md:gap-[50px]
    `,
    container: `flex gap-4 ${styles.container}
                md:flex-row md:gap-2
    `,
    innerContainer: `flex flex-col gap-4 justify-center w-[55%] ${styles.innerContainer}`,
    heading: `text-[32px] font-Suisse uppercase max-w-[75%] ${styles.mainheading}
    `,
    button_container: `flex sm:gap-[40px] ${styles.button_container}`,
    button: `text-[16px] font-[400] max-w-[210px] w-full py-[12px] px-[40px] text-white ${styles.mainbutton}
    `
}

const rewardStyle = {
    outerContainer: `flex flex-col gap-[20px] bg-liveGameBackground rounded-[10px] px-[25px] py-[20px] pb-[40px] ${styles.outerContainer1}`,
    tabsbutton: `px-[60px] w-[250px] py-[3px] z-[1] ${styles.tabsbutton}`,
    header: `flex justify-end flex-row
    `,
    headingContainer: `flex flex-row px-[15px] py-[7px] rounded-[8px] text-[14px] relative font-normal ${styles.headingContainer} 
    `, 
    backButtonContainer:`max-w-[100px]`,
    activeButton2: `${styles.activeButton2}`,
    earnedRewards: `flex gap-[2px] items-center cursor-pointer`,
    earnedRewardsText: `text-[15px] text-primaryGold hover:underline`,
    heading: `font-Suisse text-[22px] font-[700]`,
    signUp: `text-[12px] text-right block md:hidden`,
    link: `cursor-pointer text-secondaryRed`,
    rewardDataContainer: `flex flex-row gap-[20px] flex-wrap w-full ${styles.rewardDataContainer}`,
    spinnerContainer: `flex justify-center items-center w-full min-h-[300px]`,
    noRewardsMessage: ` flex flex-col justify-center items-center w-full min-h-[300px] text-center text-white text-[14px]
                    md:text-[18px] md:font-[600] 
    `,
    noRewardsText: `text-center text-white text-[14px]
                    md:text-[18px] md:font-[600]`,
    noRewardsImage: 'max-w-[300px] w-full h-auto',
    noRewardsButton: `pt-2`,
    workInProgress: `max-w-[300px] w-full h-auto`,
    earnedRewardsHeadingContainer: `flex gap-2 items-center`,
    tabContainer:`relative flex items-center py-[5px] px-[15px] rounded-[6px] ${styles.headingContainer}`,
    tab:`w-[225px] h-[28px] absolute z-[99] outline-none opacity-0`,
    tabLabel:`w-[225px] h-[28px] px-[50px] py-[3px] text-[14px] font-normal flex items-center justify-center cursor-pointer z-[999] relative`,
    indicator: `absolute top-[5px] left-[7px] w-[225px] h-[28px] z-[9] bg-white text-themeColor border border-[rgba(0,0,0,0.04)] shadow-[0_3px_8px_rgba(0,0,0,0.12),0_3px_1px_rgba(0,0,0,0.04)] rounded-[7px] transition-all ease-out duration-200 ${styles.indicator}`,
}

// clip-path-[path('M25.9721 24.8389C22.8253 12.219 32.3716 0 45.378 0H590C601.046 0 610 8.95431 610 20V173C610 184.046 601.046 193 590 193H83.5294C74.3475 193 66.3451 186.748 64.1235 177.839L25.9721 24.8389ZM0.0737305 0.145481C0.0332031 0.146042 0 0.113313 0 0.072744C0 0.0325686 0.0325928 0 0.0727539 0H10.5981L0.0737305 0.145481Z')]
const imageContainerStyle = {
    image_container: `px-[10px] py-[50px] w-[45%] bg-right rounded-b-[10px] md:rounded-b-0 bg-[rgba(255, 255, 255, 0.11)]
    bg-no-repeat bg-contain flex justify-center items-center
                      sm:p-[30px] ${styles.image_container} h-[unset] md:h-[200px]
    `,
    image_data: `flex items-center justify-center text-center gap-[25px] relative left-[39px] ${styles.image_data}`,
    data_container: `flex flex-col items-center`,
    points_heading: `text-[17px] uppercase sm:text-[18px] font-Barlow font-[700]
                     md:text-[26px] ${styles.points_heading}
    `,
    points: `text-[26px] sm:text-[68px] font-[700] text-white text-stroke font-Barlow flex items-end leading-[88px] ${styles.points}`,
    divider: `w-[2px] h-[128px] sm:h-[100px] ${styles.divider}`,
}

const rewardDataStyle = {
    outerContainer: `flex flex-col w-[32%] bg-themeColor rounded-[25px] px-[20px] py-[20px] gap-2 relative 
                    md:gap-4 ${styles.outerContainer}
    `,
    topContainer: `flex gap-2 flex-grow justify-between
                    md:gap-4
    `,
    rewardDetails: `flex flex-col justify-between gap-2
                    md:flex-row md:gap-0
    `,
    earnedRewardDetails:`flex flex-col justify-between gap-2
                     md:gap-0`,
    imageContainer: `flex flex-row gap-4 justify-between`,
    rewardImage: `w-[70px] h-[70px] ${styles.rewardImage}`,
    rewardCodeSection: `flex items-center justify-between px-[15px] py-[5px] gap-2 bg-themeShadowColor rounded-[10px]`,
    titleContainer:`flex gap-2 flex-col`,
    codeText:`text-[14px] opacity-80`,
    rewardDescription: `flex flex-col gap-1`,
    progressBarContainer: `flex items-center`,
    progressContainer: `w-full h-[6px] bg-white rounded-[4px] relative
                        md:h-[8px]
    `,
    progressBar: `h-full bg-primaryGold rounded-[4px]`,
    percentText: `ml-2 text-[13px]
                md:text-[14px]
    `,
    pointsPrice: `text-left`,
    gauge: `relative w-[12rem] h-[123px] ${styles.gauge}`,
    gauge__svg: `size-full rotate-180 animate-progress min-h-[198px] ${styles.gauge__svg}`,
    gauge_txt: `absolute top-10 left-[46%] transform -translate-x-1/2 text-center animate-number ${styles.gauge_txt}`,
    gauge__value: `text-[18px] font-medium text-lighttext ${styles.gauge__value}`,
    gauge_point: `text-[24px] leading-normal text-primaryGold pr-[8px] ${styles.gauge_point}`,
    gauge__label:  `text-[14px] font-medium text-lighttext block ${styles.gauge__label}`,
    gauge__circle_main: `stroke-current text-gray-200 `,
    gauge__circle_percent:  `stroke-current text-primaryGold animate-fill`,
    ribbonContainer: `md:hidden w-[130px] h-[130px] overflow-hidden absolute top-0 right-0`,
    ribbonText: `absolute w-[154px] p-[6px] bg-primaryGold text-center top-[24px] right-[-43px] rotate-45 font-[700] text-[12px] uppercase`,
    heading: `text-[15px] font-Suisse font-[700] leading-[18px]
               md:text-[17px] md:leading-[24px] ${styles.heading}
    `,
    subHeading: `text-[12px] font-[400] text-primaryGold
                 md:text-[14px] ${styles.subHeading}
    `,
    clickableText:`cursor-pointer hover:underline`,
    totalPoints: `text-[13px] text-rewardsPrimaryColor whitespace-nowrap 
                  md:text-[15px]
    `,
    bottomContainer: `flex items-center relative justify-between
                      md:gap-4
    `,
    divider: `hidden w-[2px] h-[90%] bg-[#D9D9D9]
              md:block
    `,
    remainingDetails: `flex flex-col gap-2 items-center text-[16px] font-[400] md:text-[20px] text-primaryGold
    `,
    remainingDetailsHidden: `cursor-default flex-row gap-[6px] flex items-center text-[13px] w-full flex items-center justify-center border border-primaryGold bg-white/25 shadow-lg shadow-[#696A6F]/37 backdrop-blur-lg rounded-[30px] text-primaryGold uppercase ${styles.remainingDetailsHidden}
    `,
    remainingdiv: `flex flex-col items-center text-[13px] ${styles.remainingdiv}`,
    badge_span: `w-[25px] h-[25px] absolute top-[-12px] right-[-2px] rotate-[-20deg] blur-[0.5px] ${styles.badge_span}`,
    remainingDetailsAfterClaim: `hidden flex-col gap-0 items-center text-[13px]
                             md:flex
    `,
    button: `!py-[7px] w-full ${styles.button}`,
}

export { redeemRewardsStyle, rewardStyle, rewardDataStyle, imageContainerStyle }